/**
 * Copyright (c) 2017-present, Tomaruba, Inc.
 * All rights reserved.
 *
 */
import './AutoActionTaskView.scss'
import React from 'react'
import _ from 'lodash'
import r from '../../../util/Renderer'
import { DeleteButton, ListItem, TextInput } from '../../atoms'
import { Edit, ListGroup } from '../../molecules'
import Cell from '../../templates/Cell'
import LocalArea from '../../templates/LocalArea'
import AutoActionConfigView from '../../organisms/auto_action/AutoActionConfigView'
import AutoTaskActions from '../../../action/auto_action/AutoTaskActions'
import { NavigationDrawer, NormalButton, TextButton } from 'ui-library/dist/external/components'

function AutoActionTaskView(props) {
  const id = props.match.params.id
  const showEdit = _.propertyOf(props)('showEdit') || false
  const toolbar = { label: '自動タスク', items: props.accountMenu }

  return (
    <div id="AutoActionTask">
      <NavigationDrawer toolbar={toolbar} navigations={props.navigations} />

      <LocalArea>
        {/*<div className="LocalArea--left">*/}
        {/*<SearchField placeholder="名前" name="search_keywords"  />*/}
        {/*</div>*/}
        <div className="LocalArea--right">
          <NormalButton onClick={() => AutoTaskActions.onCreate()}>新規作成</NormalButton>
        </div>
      </LocalArea>
      <div className="AutoActionTask__List">
        <ListGroup border="underline" className="ItemGroup">
          {props.tasks.map(task => new AutoTaskRowItem(task))}
        </ListGroup>

        {r.renderIf(showEdit)(
          // 設定されている値を View に渡す
          <AutoTaskEditView id={id} task={props.task} room_options={props.room_options} site_referrer_options={props.site_referrer_options} />
        )}
      </div>
    </div>
  )
}

function AutoTaskRowItem(auto_action_task) {
  return (
    <ListItem key={auto_action_task.id} className="Item">
      <div className="col-12">
        <div className="row">
          <div className="col-8 col-lg-8 align-self-center">
            <Cell className="Item__Name">
              <span>{auto_action_task.name}</span>
            </Cell>
          </div>
          <div className="ml-auto col-auto align-self-center">
            <Cell className="Item__Action">
              <TextButton onClick={() => AutoTaskActions.onCreateWithCopy(auto_action_task.id)}>コピーを新規作成</TextButton>
            </Cell>
          </div>
          <div className="ml-auto col-auto align-self-center">
            <Cell className="Item__Action">
              <NormalButton onClick={() => AutoTaskActions.onUpdate(auto_action_task)}>編集</NormalButton>
            </Cell>
          </div>
        </div>
      </div>
    </ListItem>
  )
}

function AutoTaskEditView(props) {
  const task = props.task

  return (
    <Edit
      title={props.id ? `自動タスクID：${props.id}` : '自動登録タスクの作成'}
      buttonLabel={props.id ? '更新' : '作成'}
      onSubmit={props.id ? () => AutoTaskActions.onRequestUpdate(task) : () => AutoTaskActions.onRequestCreate(task)}
      onCancel={AutoTaskActions.onCancel}
    >
      <div className="EditArea__row">
        <div className="EditArea__row--full">
          <div className="EditArea__column">
            <TextInput value={task.name} type="text" name="name" label={'自動タスク名'} placeholder="自動タスクを識別するための名前" option="required" onChange={AutoTaskActions.onEdit} />
          </div>
        </div>
      </div>

      <AutoActionConfigView
        config={task.getConfig()}
        rooms={props.room_options}
        site_referrers={props.site_referrer_options}
        room_ids={task.room_ids}
        site_referrer_ids={task.site_referrer_ids}
        onEdit={AutoTaskActions.onEdit}
      />

      <div className="EditArea__row">
        <div className="EditArea__row--full">
          <div className="EditArea__column">
            <TextInput value={task.title} type="text" name="title" label={'タイトル'} placeholder="タスクのタイトル" option="required" onChange={AutoTaskActions.onEdit} />
          </div>
        </div>
      </div>

      <div className="EditArea__column">
        <div className="textInput__label textInput__label-">
          詳細内容
          <div className="textInput__optionIcon" />
        </div>
        <textarea className="EditArea__row--full" name="body" value={task.body} rows="12" onChange={AutoTaskActions.onEdit} />
      </div>

      {r.renderIf(props.id)(
        <div className="EditArea__row">
          <div className="EditArea__row--full">
            <div className="EditArea__column">
              <DeleteButton onClick={() => AutoTaskActions.onRequestDelete(props.id)}>削除</DeleteButton>
            </div>
          </div>
        </div>
      )}
    </Edit>
  )
}

export default AutoActionTaskView
